import { PayloadAction } from '@reduxjs/toolkit'
import { isSpotSubType } from '@spiaggeit/spit-core'
import cloneDeep from 'lodash/cloneDeep'
import {
  FeaturedService,
  FormattedServices,
  ServiceLimitType,
} from '@/models/service'
import { BookingAvailability } from '@/store/bookingAvailabilitySlice'
import { getObjectsComparison } from '@/utils/getObjectsComparison'
import { normalizeReservation } from '@/utils/normalizeReservation'
import { getServiceKeyFromId } from '@/utils/serviceIdKeyUtils'
import { CartSliceState } from '../type'

export function addFeaturedServiceToCart(
  state: CartSliceState,
  action: PayloadAction<{
    formattedServices: FormattedServices
    quantity: number
    featuredService: FeaturedService
  }>
) {
  const key = getServiceKeyFromId(action.payload.featuredService.serviceId)

  if (state.activeBookingType === BookingAvailability.TICKETS) {
    state.cartReservations = [
      {
        ...state.cartReservations[0],
        services: {
          ...state.cartReservations[0].services,
          [key]: action.payload.quantity,
        },
      },
    ]
    return
  }

  const { formattedServices } = action.payload

  if (
    action.payload.featuredService.minimumLimitType !== ServiceLimitType.FLAT
  ) {
    // add the service to the "first" reservation
    const reservationToUpdate =
      formattedServices &&
      state.cartReservations.find((res) =>
        formattedServices[key]?.sectors.includes(res.sectorId)
      )

    state.cartReservations = state.cartReservations.map((res) => {
      if (
        reservationToUpdate &&
        !getObjectsComparison(
          normalizeReservation(res),
          normalizeReservation(reservationToUpdate)
        )
      ) {
        return res
      } else
        return {
          ...res,
          services: { ...res.services, [key]: action.payload.quantity },
        }
    })
    return
  }

  const newCartReservations = cloneDeep(state.cartReservations).map((res) => {
    // reset quantity of service, if already present
    if (typeof res.services[key] === 'number') {
      return { ...res, services: { ...res.services, [key]: 0 } }
    }
    return res
  })

  const spotsReservations = newCartReservations.filter(
    (res) =>
      isSpotSubType(res.spotType) &&
      action.payload.featuredService.sectors.includes(res.sectorId)
  )
  for (let i = 0; i < action.payload.quantity; i++) {
    // find first resertion with minimum not yet at "limit"
    const res = spotsReservations.find((res) => {
      const quantity = res.services[key] ?? 0
      return quantity < action.payload.featuredService.minimumQuantity
    })

    const toUpdate = res ?? spotsReservations[0]
    const newQuantity = toUpdate.services[key] ?? 0
    toUpdate.services[key] = newQuantity + 1
  }

  state.cartReservations = newCartReservations
}
